<!-- Thin -->
<thin-layout *ngIf="layout === 'thin'"></thin-layout>
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

